import React from 'react';
import { Card, CardImg, CardText, CardBody, CardTitle, Button } from 'reactstrap';
import { Link } from 'react-router-dom';
import { Loading } from './LoadingComponent';
import { FadeTransform } from 'react-animation-components';

function RenderFinanceCard({ item, isLoading, errMess }) {
    if (isLoading) {
        return (
            <Loading />
        );
    }
    else if (errMess) {
        return (
            <h4>{errMess}</h4>
        );
    }
    else
        return (
            <Card>
                <Link to={'/finance'} >
                    <FadeTransform in
                        transformProps={{
                            exitTransform: 'scale(0.5) translateY(-50%)'
                        }}>
                        <CardImg width="100%" src={item.image} alt={item.name} />
                        <div className="card-link-color">
                            <CardBody>
                                <CardTitle>{item.name}</CardTitle>
                                <CardText>{item.description} <Button outline>Enter</Button></CardText>
                            </CardBody>
                        </div>
                    </FadeTransform>
                </Link>
            </Card>
        );
}

function RenderAutoCard({ item, isLoading, errMess }) {
    if (isLoading) {
        return (
            <Loading />
        );
    }
    else if (errMess) {
        return (
            <h4>{errMess}</h4>
        );
    }
    else
        return (
            <Card>
                <Link to={'/auto'} >
                    <FadeTransform in
                        transformProps={{
                            exitTransform: 'scale(0.5) translateY(-50%)'
                        }}>
                        <CardImg width="100%" src={item.image} alt={item.name} />
                        <div className="card-link-color">
                            <CardBody>
                                <CardTitle>{item.name}</CardTitle>
                                <CardText>{item.description} <Button outline>Enter</Button></CardText>
                            </CardBody>
                        </div>
                    </FadeTransform>
                </Link>
            </Card>
        );
}

function RenderKetoCard({ item, isLoading, errMess }) {
    if (isLoading) {
        return (
            <Loading />
        );
    }
    else if (errMess) {
        return (
            <h4>{errMess}</h4>
        );
    }
    else
        return (
            <Card>
                <Link to={'/keto'} >
                    <FadeTransform in
                        transformProps={{
                            exitTransform: 'scale(0.5) translateY(-50%)'
                        }}>
                        <CardImg width="100%" src={item.image} alt={item.name} />
                        <div className="card-link-color">
                            <CardBody>
                                <CardTitle>{item.name}</CardTitle>
                                <CardText>{item.description} <Button outline>Enter</Button></CardText>
                            </CardBody>
                        </div>
                    </FadeTransform>
                </Link>
            </Card>
        );
}

function Home(props) {
    return (
        <div className="container">
            <div className="row align-items-start">
                <div className="col-12 col-md m-1">
                    <RenderFinanceCard item={props.management}
                        isLoading={props.financesLoading}
                        errMess={props.financesErrMess} />
                </div>
                <div className="col-12 col-md m-1">
                    <RenderAutoCard item={props.auto}
                        isLoading={props.cardsLoading}
                        errMess={props.cardsErrMess} />
                </div>
                <div className="col-12 col-md m-1">
                    <RenderKetoCard item={props.dish}
                        isLoading={props.cardsLoading}
                        errMess={props.cardsErrMess} />
                </div>
            </div>
        </div>
    );
}

export default Home;


// WEBPACK FOOTER //
// ./src/components/HomeComponent.js